// views/Dashboard/PainelExecutivo/areas/AreaEquipes.tsx
//
// Área "Equipes" do Painel Executivo: BI de eficiência das equipes de Goiânia e
// Morrinhos (#6198). Liga os dados (`useEquipesData`) à interface (`EquipesTela`).
//
// Período próprio, e não o filtro do topo do painel: aquele recorta por MÊS de
// referência da fatura; aqui a pergunta é sobre o ritmo de trabalho das pessoas
// ("últimos 30 dias"), com grão de dia — o mesmo seletor do Dashboard de
// Faturamento, cuja regra de prazo este BI reaproveita.
import React, { useMemo, useState } from 'react';
import { useToast } from '../../../../src/contexts/ToastContext';
import EquipesTela, { type FiltroUnidade } from '../sections/equipes/EquipesTela';
import { useEquipesData } from '../sections/equipes/useEquipesData';
import { exportarEquipes } from '../sections/equipes/exportarEquipes';
import {
  calcularJanelaEmissao,
  rotuloPeriodoEmissao,
  type PeriodoEmissao,
} from '../../DashboardFaturamento/lib/periodoEmissao';

const AreaEquipes: React.FC = () => {
  const [periodo, setPeriodo] = useState<PeriodoEmissao>('ultimos30');
  const [filtroUnidade, setFiltroUnidade] = useState<FiltroUnidade>('todas');
  const [exportando, setExportando] = useState(false);
  const { addToast } = useToast();

  const hoje = useMemo(() => new Date(), []);
  const janela = useMemo(() => calcularJanelaEmissao(periodo, hoje), [periodo, hoje]);
  const dados = useEquipesData(janela);

  const handleExportar = () => {
    setExportando(true);
    try {
      const visiveis = filtroUnidade === 'todas'
        ? dados.unidades
        : dados.unidades.filter((u) => u.unidade === filtroUnidade);
      exportarEquipes(visiveis, rotuloPeriodoEmissao(periodo));
    } catch (e: any) {
      console.error('Erro ao exportar o BI de equipes:', e);
      addToast(e?.message || 'Não foi possível gerar o Excel.', 'error');
    } finally {
      setExportando(false);
    }
  };

  return (
    <EquipesTela
      unidades={dados.unidades}
      filtroUnidade={filtroUnidade}
      onFiltroUnidade={setFiltroUnidade}
      periodo={periodo}
      onPeriodo={setPeriodo}
      loading={dados.loading}
      erro={dados.erro}
      carregandoPrazo={dados.carregandoPrazo}
      erroPrazo={dados.erroPrazo}
      ultimaAtualizacao={dados.ultimaAtualizacao}
      onAtualizar={dados.recarregar}
      onExportar={handleExportar}
      exportando={exportando}
    />
  );
};

export default AreaEquipes;
